import React from 'react';
import { Box, Typography } from '@mui/material';
import AddOutlined from '@mui-symbols-material/w400/AddOutlined';
import { useTranslation } from 'react-i18next';
import styles from './SectionHeader.module.scss';
import { CdfActionButton } from '@commonComponents/controls/buttons/CdfButtons/CdfActionButton';

interface SectionHeaderProps {
  sectionKey: 'header' | 'footer';
  sectionLabel: string;
  onAddClick: (section: 'header' | 'footer') => void;
}

export const SectionHeader: React.FC<Readonly<SectionHeaderProps>> = ({ sectionKey, sectionLabel, onAddClick }) => {
  const { t } = useTranslation(['reportImages']);

  return (
    <Box className={styles.sectionHeader}>
      <Typography variant="h3" component="h2">
        {sectionLabel}
      </Typography>
      <Box className={styles.buttonContainer}>
        <CdfActionButton
          variant="text"
          color="primary"
          icon={<AddOutlined />}
          text={t('common.addButtonText')}
          onClick={() => onAddClick(sectionKey)}
          data_testId={`add-image-button-${sectionKey}`}
        />
      </Box>
    </Box>
  );
};
